import BASE_URL from "components/BaseUrl/apiConfig";

//common method page
export const logoutUser = () => {
  // Local Storage se user ko logout karne wale code yahan likhe
  localStorage.removeItem("userData"); // Yahan 'userToken' ko apne use case ke hisab se change kare
};

// Function to delete an expense type
// components/CommanMethod/Commanmethod.js
export const deleteExpenseType = async (
  expensedescTypeId,
  setExpenseTypes,
  MySwal
) => {
  try {
    const response = await fetch(
      `${BASE_URL}/api/ExpenseDescriptiontype/DeleteExpenseDescritionType?expensedescTypeId=${expensedescTypeId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const result = await response.json();

    if (result.success) {
      // If the API response indicates success, update the state to remove the deleted expense type
      setExpenseTypes((prevExpenseTypes) =>
        prevExpenseTypes.filter(
          (expenseType) => expenseType.expensedescTypeID !== expensedescTypeId
        )
      );

      // Show success alert
      MySwal.fire({
        icon: "success",
        title: "Deleted!",
        text: "The Expense Type has been deleted successfully.",
      });
    } else {
      // If the API response indicates failure, show error alert
      MySwal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while deleting the expense type. Please try again later.",
      });
    }
  } catch (error) {
    console.error("Error deleting expense type:", error);
    // Notify the user about the error
    MySwal.fire({
      icon: "error",
      title: "Error!",
      text: "An error occurred while deleting the expense type. Please try again later.",
    });
  }
};

//
//here is the code of the compress image size
//
export const compressAndUploadImage = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const image = new Image();
      image.src = e.target.result;
      image.onload = () => {
        const canvas = document.createElement("canvas");
        const maxDimensions = 800; // Define your maximum dimensions here
        if (image.width > maxDimensions || image.height > maxDimensions) {
          const scale = Math.min(
            maxDimensions / image.width,
            maxDimensions / image.height
          );
          canvas.width = image.width * scale;
          canvas.height = image.height * scale;
        } else {
          canvas.width = image.width;
          canvas.height = image.height;
        }
        const ctx = canvas.getContext("2d");
        ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
        // Determine the original image format
        const originalImageFormat = file.type; // This assumes the file parameter has the correct MIME type.
        canvas.toBlob(
          (blob) => {
            resolve(blob);
          },
          originalImageFormat,
          0.8
        ); // You can adjust the compression quality as needed.
      };
    };
    reader.readAsDataURL(file);
  });
};
